import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'kia-tooltip',
  styleUrl: 'kia-tooltip.scss',
})
export class Tooltip {
  @Prop() toolTitle: string;

  render() {
    return (
      <a role="button" tabindex={0} title={this.toolTitle} class="kia_price_card--tooltip">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_865_453)">
            <path
              d="M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8C14.6668 4.3181 11.6821 1.33333 8.00016 1.33333C4.31826 1.33333 1.3335 4.3181 1.3335 8C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z"
              stroke="#05141F"
              stroke-width="1.33333"
            />
            <path d="M8 10.6667V8" stroke="#05141F" stroke-width="1.33333" stroke-linecap="square" />
            <rect x="7.3335" y="4.66667" width="1.33333" height="1.33333" fill="#05141F" />
          </g>
          <defs>
            <clipPath id="clip0_865_453">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
    );
  }
}
